import React, { useState } from "react";

import DownloadIcon from "@mui/icons-material/Download";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { Stack, Typography } from "@mui/material";
import { InvestorsTable, RoleComponentGuard, Search } from "components";
import { Button } from "components/forms";
import { Menu } from "components/popups";
import { useModals } from "hooks";
import { useDealActions } from "store";

import { RoleName } from "../../constants";

export const Investors: React.FC = () => {
  const [value, setValue] = useState<string>("");
  const { investorModal } = useModals();

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    setValue(event.target.value);
  };

  const { getInvestorsListAction, uploadInvestorRelationsAction } = useDealActions();

  return (
    <RoleComponentGuard
      availableRoles={[RoleName.Admin, RoleName.Analyst]}
      RenderInstead={
        <Stack sx={{ alignItems: "center", bgcolor: "#f6f8fc", flexGrow: 1, p: "16px" }}>
          <Stack sx={{ width: "100%", mb: "50px", justifyContent: "center", alignItems: "center" }}>
            <Typography sx={{ fontSize: "2.5em", color: "#173c4c", fontWeight: 500 }}>
              The content of this page is not available to you
            </Typography>
          </Stack>
        </Stack>
      }
    >
      <Stack sx={{ alignItems: "center", bgcolor: "#f6f8fc", flexGrow: 1, overflow: "auto", gap: "16px", p: "16px" }}>
        <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between", alignItems: "center" }}>
          <Search value={value} onChange={handleChange} placeholder="Search" />
          <Stack direction="row" sx={{ gap: "20px", alignItems: "center" }}>
            <Button title="Add Investor" onClick={() => investorModal({ isOpen: true })} />
            <RoleComponentGuard availableRoles={[RoleName.Admin, RoleName.Analyst]}>
              <Stack direction="row" sx={{ gap: "20px", alignItems: "center" }}>
                <Menu
                  options={[
                    {
                      title: "Download List",
                      icon: <DownloadIcon sx={{ mr: "5px", width: 19, height: 19 }} />,
                      onClick: getInvestorsListAction
                    },
                    {
                      title: "",
                      icon: (
                        <div>
                          <label
                            style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
                            htmlFor="input-upload-investor-relations"
                          >
                            <FileUploadOutlinedIcon sx={{ mr: "5px", width: 19, height: 19 }} />
                            Upload Entity Hierarchy
                          </label>
                        </div>
                      )
                    }
                  ]}
                />
                <input
                  type="file"
                  hidden
                  onChange={(e) => {
                    e.target.files && uploadInvestorRelationsAction(e.target.files[0]);
                  }}
                  id="input-upload-investor-relations"
                />
              </Stack>
            </RoleComponentGuard>
          </Stack>
        </Stack>
        <InvestorsTable searchValue={value} />
      </Stack>
    </RoleComponentGuard>
  );
};
